import {route} from 'react-router-typesafe-routes';

export const contentRoutesPath = route({
  children: {
    article: route({
      path: ':articleId',
    }),
  },
  path: 'content',
});
